import { NgForOf, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { DialogModule } from 'primeng/dialog';
import { AuthService } from '../../../core/services/auth.service';
import { AppMenuitemComponent } from './menu-item/menu-item.component';
import { ProfileSectionComponent } from './profile-section/profile-section.component';

@Component({
  standalone: true,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  imports: [
    NgForOf,
    NgIf,
    AppMenuitemComponent,
    AvatarModule,
    DialogModule,
    ProfileSectionComponent,
  ],
})
export class SidebarComponent implements OnInit {
  model: any[] = [];

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.model = [
      {
        label: 'Home',
        items: [
          { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/', 'dashboard'] },
          {
            label: 'Ansambluri rezidentiale',
            icon: 'pi pi-fw pi-building',
            routerLink: ['/', 'complexes'],
          },
          // {
          //   label: 'Pagini',
          //   icon: 'pi pi-fw pi-th-large',
          //   routerLink: ['/', 'pages'],
          // },
          {
            label: 'Statistici',
            icon: 'pi pi-fw pi-chart-bar',
            routerLink: ['/', 'stats'],
          },
          // {
          //   label: 'Utilizatori',
          //   visible: this.authService.isAdmin(),
          //   icon: 'pi pi-fw pi-users',
          //   routerLink: ['/', 'users'],
          // },
        ],
      },
    ];
  }
}
